module.exports = __webpack_public_path__ + "img/virtual.617a230f.jpg";